import 'rxjs/add/observable/from';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/mergeMap';
import { Observable } from 'rxjs/Observable';
import type { Location, RouterActionPush } from '@atlassian/react-resource-router';
import { REFRESH_SOURCE_FAILURE } from '../../model/constants';
import cardDeleteService from '../../rest/card-delete/index.tsx';
import { removeSelectedIssueFromUrl } from '../../services/routing/selected-issue-url-change';
import { refreshDataRequest } from '../../state/actions/app';
import {
	CARD_DELETE_REQUEST,
	type CardDeleteRequestAction,
	cardDeleteSuccess,
	cardDeleteFailure,
} from '../../state/actions/cards/delete';
import { getBaseUrl } from '../../state/selectors/app';
import type { MiddlewareAPI, ActionsObservable } from '../../state/types';

export const cardDeleteEpic =
	(getLocation: () => Location, push: RouterActionPush) =>
	(action$: ActionsObservable, store: MiddlewareAPI) =>
		action$.ofType(CARD_DELETE_REQUEST).mergeMap((action: CardDeleteRequestAction) => {
			const {
				payload: { cardId },
				meta: {
					optimistic: { id: optimisticId },
				},
			} = action;

			const state = store.getState();
			const baseUrl = getBaseUrl(state);

			push(removeSelectedIssueFromUrl(getLocation()));
			return cardDeleteService(baseUrl, String(cardId))
				.flatMap(() => {
					const actions = [cardDeleteSuccess(cardId, optimisticId)];
					return Observable.from(actions);
				})
				.catch(() =>
					Observable.from([
						cardDeleteFailure(cardId, optimisticId),
						refreshDataRequest(REFRESH_SOURCE_FAILURE),
					]),
				);
		});
